import React from 'react';
import { COMMON_TEXT } from '../../helpers/common-text';
import './IpRestrictionAlert.less';


/**
 * Simple IP Restriction Alert Component
 * Displays a custom alert box when user's IP address is not whitelisted
 */
const IpRestrictionAlert = ({ clientIp }) => {
    return (
        <div className="ip-restriction-alert">
            <div className="alert-icon">
                <i className="pi pi-exclamation-triangle"></i>
            </div>
            <div className="alert-content">
                <div className="alert-message">{COMMON_TEXT.IP_RESTRICTION_ERROR_MESSAGE}</div>
                <div className="alert-message">{COMMON_TEXT.IP_RESTRICTION_SOURCE_IP}: {clientIp || 'Unknown'}</div>

            </div>
        </div>
    );
};

export default IpRestrictionAlert;

